export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50 scroll-mt-16">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 mb-3">联系我们</h2>
        <p className="text-sm text-foreground-500 mb-8 max-w-lg mx-auto">
          有影片推荐、合作意向或意见建议？欢迎通过以下方式与萝卜影视团队取得联系。
        </p>
        <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/60 inline-block">
          <div className="flex flex-col sm:flex-row items-center gap-4 md:gap-8">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/15">
                <i className="ri-mail-line text-primary-400 text-lg"></i>
              </span>
              <div className="text-left">
                <div className="text-xs text-foreground-500">投稿与合作</div>
                <div className="text-sm font-medium text-foreground-200">contact@luobo-movie.film</div>
              </div>
            </div>
            <div className="w-px h-8 bg-background-300/60 hidden sm:block"></div>
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/15">
                <i className="ri-chat-smile-2-line text-accent-400 text-lg"></i>
              </span>
              <div className="text-left">
                <div className="text-xs text-foreground-500">影迷社群</div>
                <div className="text-sm font-medium text-foreground-200">加入讨论群</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}